import BigPicklistControl from 'Components/ComponentLibrary/Components/Inputs/Picklist/BigPicklistControl';
import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/WhatIfTemplate/BaseOverride';

export default fr.metaOverride({ base: BaseOverride })
  .overrideAll({
    _customHelperProps: {
      showRequiredHelperText: false,
    },
  })
  .typeOverride('picklist', {
    _component: () => BigPicklistControl,
  });
